const types = {
	pointsPurchase: 'PointsPurchase',
	ticketPurchase: 'TicketPurchase'
}

const discountCouponConstants = {
	types
}

export default discountCouponConstants
